import { DraggableScroll } from "@verde/compose-ui";
import { useFetchCreditUsages } from "@verde/entities";
import { QueueListIcon } from "@verde/icons";
import { Button, Skeleton, TagButton, Tooltip } from "@verde/ui-core";
import { formatDate } from "@verde/utils";
import { useReducer } from "react";
import { useNavigate } from "react-router-dom";
import { useCreditProfilePanel } from "./panel";
import PanelSearchClientHistoryDrawer from "./panel-search-client-history-drawer";

const MAX_SIZE = 10;

export function PanelSearchClientHistory() {
  const navigate = useNavigate();
  const { resource } = useCreditProfilePanel();

  const [listOpen, toggleListOpen] = useReducer((state) => !state, false);

  const { data, isLoading } = useFetchCreditUsages({
    size: MAX_SIZE,
    sort: "created_at:desc",
  });

  if (isLoading) {
    return <Skeleton height={45} />;
  }

  if (!data?.data?.length) return null;

  return (
    <>
      <div className="grid grid-cols-[1fr_auto] items-center gap-6 border-t border-neutral-light-2 pb-2 pt-4">
        <DraggableScroll
          items={data.data
            .filter(({ id }) => id !== resource.data?.id)
            .map(({ id, client, created_at }) => {
              return (
                <Tooltip
                  key={`raio-x-history-item-${id}`}
                  side="bottom"
                  content={
                    <small>
                      Consultado em{" "}
                      {formatDate(created_at, { display: "both" })}
                    </small>
                  }
                >
                  <TagButton
                    size="sm"
                    kind="darker"
                    onClick={() => {
                      navigate(`/raio-x-rural/${client.id}/${id}`);
                    }}
                    className="snap-end last:mr-12"
                  >
                    {client.name || ""}
                  </TagButton>
                </Tooltip>
              );
            })}
        />

        <Button
          kind="secondary"
          icon={<QueueListIcon />}
          onClick={toggleListOpen}
          className="h-6"
        >
          Histórico de consultas
        </Button>
      </div>

      {listOpen && <PanelSearchClientHistoryDrawer onClose={toggleListOpen} />}
    </>
  );
}
